"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactTable = require("react-table");

var _Loading = _interopRequireDefault(require("./Loading"));

var _styles = require("./styles");

var _TableBody = _interopRequireDefault(require("./TableBody"));

var _TableHead = _interopRequireDefault(require("./TableHead"));

var alignment = {
  right: 'right',
  left: 'left',
  center: 'center'
};

var Table = function Table(_ref) {
  var data = _ref.data,
      columns = _ref.columns,
      _ref$hiddenColumns = _ref.hiddenColumns,
      hiddenColumns = _ref$hiddenColumns === void 0 ? [] : _ref$hiddenColumns,
      footer = _ref.footer,
      loading = _ref.loading,
      loadingRows = _ref.loadingRows;

  var _useTable = (0, _reactTable.useTable)({
    columns: columns,
    data: data,
    initialState: {
      pageIndex: 0,
      pageSize: 20,
      hiddenColumns: hiddenColumns
    }
  }, _reactTable.useSortBy),
      getTableProps = _useTable.getTableProps,
      getTableBodyProps = _useTable.getTableBodyProps,
      headerGroups = _useTable.headerGroups,
      prepareRow = _useTable.prepareRow,
      rows = _useTable.rows;

  var columnAlign = {};
  headerGroups[0].headers.forEach(function (header) {
    columnAlign[header.id] = alignment[header.align || 'left'];
  });
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_styles.Wrapper, null, /*#__PURE__*/_react.default.createElement("table", Object.assign({}, getTableProps(), {
    style: {
      width: '100%'
    }
  }), /*#__PURE__*/_react.default.createElement(_TableHead.default, {
    headerGroups: headerGroups
  }), /*#__PURE__*/_react.default.createElement(_TableBody.default, {
    columnAlign: columnAlign,
    getTableBodyProps: getTableBodyProps,
    prepareRow: prepareRow,
    rows: rows
  })), loading && /*#__PURE__*/_react.default.createElement(_Loading.default, {
    rows: loadingRows
  })), footer && footer);
};

var _default = Table;
exports.default = _default;